export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ03.dae76543.mp3";